import { CircularProgress, styled } from "@mui/material";
import { colors } from "@zapalacorp/tokens";

interface DocumentBadgeProps {
  color?: string;
  disabled?: boolean;
}

interface TextButtonContainerProps {
  disabled?: boolean;
}

export const TextButtonText = styled("span")(({ color, disabled }: DocumentBadgeProps) => ({
  color: disabled ? colors.gray400 : color,
  fontFamily: "Manrope",
  fontSize: "12px",
  fontStyle: "normal",
  fontWeight: 600,
  lineHeight: "16px",
  letterSpacing: "0.5px",
  whiteSpace: "nowrap",
}));

export const TextButtonContainer = styled("div")(({ disabled }: TextButtonContainerProps) => ({
  marginLeft: "12px",
  display: "flex",
  padding: "10px 10px 10px 8px",
  justifyContent: "center",
  alignItems: "center",
  gap: "6px",
  flex: "1 0 0",
  alignSelf: "stretch",
  cursor: disabled ? "not-allowed" : "pointer",
}));

export const DocumentCircularProgress = styled(CircularProgress)(() => ({
  color: colors.gray400,
}));
